import { Location } from '@angular/common';
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { routes } from '../../app.routes';
import { HomeComponent } from '../../views/home/home.component';
import { CatlougeTypeConstants } from '../constants';
import { UserService } from './user.service';
import { SnowplowService } from '../analytics/snowplow.service';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  currentRoute: any;
  currentSlugName: any;
  activeMenu: any;
  slugName: any;
  headerTabs: string = '';

  constructor(
    public location: Location,
    public router: Router,
    public userService: UserService,
    public SnowplowService: SnowplowService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) {
    if (isPlatformBrowser(this.platformId)) {
      if (location.path() === '') {
        localStorage.removeItem('slugName');
      }
    
      this.slugName = localStorage.getItem('slugName');
      this.currentSlugName = this.userService.currentSlugName;

      router.events.subscribe(val => {
        this.currentRoute = location.path() !== "" ? location.path() : "/";
      });

      let dynamicRoute = [];
      dynamicRoute.push({
        path: `series`,
        component: HomeComponent
      });

      let finalRoute = [...dynamicRoute, ...routes];
      this.router.resetConfig(finalRoute);
    }
  }

  Init(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (!isPlatformBrowser(this.platformId)) {
        resolve();
        return;
      }

      if (this.location.path().startsWith('/app-pages')) {
        resolve();
        return;
      }

      if (!localStorage.getItem('deviceId')) {
        localStorage.clear();
        localStorage.setItem('deviceId', uuidv4());
      }

      const tabDataParams = {
        catlogue: CatlougeTypeConstants.catlogue,
        call: "gettabs"
      };

      this.userService.getBuildSummary().subscribe({
        next: (buildSummaryRes: any) => {
          localStorage.setItem('buildSummary', JSON.stringify(buildSummaryRes.result));
          this.userService.dynamicTab().subscribe({
            next: (tabRes) => {
              if (tabRes.filter_type) {
                const decoded = atob(tabRes.filter_type);
                localStorage.setItem('filterTypeData', decoded);
              } else {
                const fallback = '{"is_cloudfront_enabled":"0","bucket":"digi-file-img"}';
                localStorage.setItem('filterTypeData', fallback);
              }

              if (tabRes.result && tabRes.result.length > 0) {
                localStorage.setItem('tabs', JSON.stringify(tabRes.result));
                const dynamicRoute: any = [];

                tabRes.result.forEach((tabResData: any, index: number) => {
                  dynamicRoute.push({
                    path: `${tabResData.slug}`,
                    component: HomeComponent
                  });

                  if (index >= tabRes.result.length - 1) {
                    const finalRoute = [...dynamicRoute, ...routes];
                    this.userService.setCurrentSlugName(tabRes.result[0].slug);
                    localStorage.setItem('continuewatching', tabRes.result[0].slug);

                    this.slugName = this.slugName || tabRes.result[0].slug;
                    this.userService.updateSelectedMenu(this.slugName);
                    this.userService.setCurrentSlugName(this.slugName);

                    this.router.resetConfig(finalRoute);
                    this.currentRoute = this.location.path();
                    this.router.navigateByUrl(this.currentRoute);
                    resolve();
                  }
                });
              } else {
                resolve();
              }
            },
            error: (error) => {
              console.error('Error fetching tabs:', error);
              this.currentRoute = this.location.path();

              if (error.response_code === 401) {
                this.userService.purgeAuth();
                window.location.href = '/';
                return;
              }

              if (!this.currentRoute?.includes('app-pages') && localStorage.getItem('profile_id')!) {
                this.router.navigate(['/500']);
              }
              resolve();
            }
          });
        },
        error: (error) => {
          console.error('Error fetching build summary:', error);
          resolve(); // Continue initialization even if build summary fails
        }
      });
      
      //  Call at app startup
      this.snowplowPing();
      this.getGeoContext();

    });

    
  }

  private snowplowPing() {
    this.SnowplowService.pingSp();
  }

  // Your Ping Method with Cookie Storage
  getGeoContext() {
    this.SnowplowService.getGeoContext().subscribe({
      next: (res: any) => {
        this.setCookie('getGeoContext', res.result);

        try {
          const decoded = JSON.parse(atob(res.result));
          console.log("decoded", decoded)
          if (decoded.country && decoded.country !== 'IN') {
            this.router.navigate(['/geo-restricted']);
          }
        } catch (err) {
          console.error('Error parsing geo context:', err);
        }
      },
      error: (err) => {
        console.error('Ping error:', err);
      }
    });
  }

  // Helper to set a session cookie
  private setCookie(name: string, value: string) {
    // No expiry → it's a session cookie
    this.document.cookie = `${name}=${encodeURIComponent(value)};path=/`;
  }

  // Helper to get cookie
  getCookie(name: string): string | null {
    const match = this.document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }
}